import { EnumOption } from './enum-option';

export const ReminderStatus = {
  Open: 0,
  Completed: 1,
  Cancelled: 2,
  Suppressed : 3,
}

export const ReminderStatusList: EnumOption[] = [
  { value: ReminderStatus.Open, label: 'Open' },
  { value: ReminderStatus.Completed, label: 'Completed' },
  { value: ReminderStatus.Cancelled, label: 'Cancelled' },
  { value: ReminderStatus.Suppressed, label: 'Suppressed' },
];